import React, { Component } from "react";
import Demo from "./children/Demo";
import "../App.css";
class Project extends Component {
  state = {};
  render() {
    return <Demo />;
  }
}

export default Project;
